
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"calendar_svg__a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 4a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H2a2 2 0 01-2-2z"}})])]),_c('g',{staticClass:"icon-stroke",attrs:{"fill":"none","stroke":"#979797","stroke-miterlimit":"50"}},[_c('path',{attrs:{"stroke-width":"2","d":"M0 4a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H2a2 2 0 01-2-2z","clip-path":"url(#calendar_svg__a)"}}),_c('path',{attrs:{"d":"M.46 6.456l14.473.188M2.432.37l.136 4.394M13.432 0l.136 4.394"}})])])
          )
        }
      }
    